<template>
    <gsc-invoice-common isNew></gsc-invoice-common>
</template>
<script>
import gscInvoiceCommon from './gscInvoiceCommon'
export default {
    name: 'gscInvoiceAdd',
    components: {
        gscInvoiceCommon
    }
}
</script>